import { useState } from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { useBillingStatus } from "@/features/billing/hooks/useBillingStatus";
import {
  PLAN_LEAD_BROWSE_FREE,
  PLAN_LINK_VIEW,
} from "@/features/billing/planCopy";

const STORAGE_KEY = "invoicevault-dismiss-trial-note";

export function ImportantNoteCard() {
  const { status } = useBillingStatus();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === "1",
  );

  if (dismissed || status?.subscribed || status?.trial_active) return null;

  const message = status?.trial_active
    ? `Pro trial — ${status.trial_days_left} days left with full access.`
    : PLAN_LEAD_BROWSE_FREE;

  return (
    <aside className="info-credits" aria-label="Important note">
      <div className="info-credits-head">
        <p className="info-credits-body">
          {message}{" "}
          <Link to={ROUTES.billing} className="link-quiet font-semibold">
            {PLAN_LINK_VIEW}
          </Link>
        </p>
        <button
          type="button"
          className="btn-dismiss"
          title="Hide after first visit"
          onClick={() => {
            localStorage.setItem(STORAGE_KEY, "1");
            setDismissed(true);
          }}
        >
          Dismiss
        </button>
      </div>
    </aside>
  );
}
